// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/child-restraint-system.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/child-restraint-system/child-restraint-system.js';

mount([g0]);
